













































import {
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import GuardarButton from '@/reusable/Modal/GuardarButton.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CodeView from '@/reusable/CodeView/CodeView.vue';

import { ScriptValidacion, Evaluaciones } from '@/interfaces/ContratoProveedor';
import { evaluarScriptEndpoint } from '@/pantallas/ContratoProveedor/Services/evaluarScriptEndpoint';

@Component({
  components: {
    CabeceraModal,
    GuardarButton,
    ModalMantenedor,
    ContenidoModal,
    FormFieldsContainer,
    CodeView,
  },
})
export default class ValidarEndpointModal extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ required: true, default: '' }) script: string;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  formFields: FormFieldDefMap = {
    endpoint: {
      label: 'Metadata Endpoint',
      id: 'endpoint',
      value: '',
    },
    resultado: {
      label: '',
      id: 'resultado',
      value: '',
    },
  };
  handleCerrar() {
    this.$emit('cerrar');
  }

  @Watch('show', { deep: true })
  handleShowChange() {
    this.formFields.endpoint.value = '';
    this.formFields.resultado.value = '';
  }

  handleScriptBlur(valor: string) {
    this.script = valor;
    this.$emit('blur', valor);
  }

  handleValidarEndpointClick() {
    this.loadingService.showLoading();
    evaluarScriptEndpoint({
      script: this.script,
      metadata: {
        usuario: 'usuario',
        password: 'password',
        endpoint: this.formFields.endpoint.value.toString(),
      },
    })
      .then((res: Evaluaciones) => {
        this.formFields.resultado.value = res.respuesta;
      })
      .finally(() => this.loadingService.hideLoading());
  }
}
